import React, { useEffect, useState } from "react";
import "../results.css";

const Schedule = () => {
  return (
    <div>
      <h1>Schedule</h1>
    </div>
  );
};

export default Schedule;
